/**
 * FileAudioIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FileAudioIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm-6.958 3C9.258 6 7 8.333 7 11.21v4.053C7 16.224 7.75 17 8.68 17h1.681v-4.632h-2.24V11.21c0-2.24 1.753-4.052 3.92-4.052 2.169 0 3.922 1.812 3.922 4.052v1.158h-2.24V17h1.68c.93 0 1.68-.776 1.68-1.737v-4.052C17.083 8.333 14.826 6 12.042 6" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FileAudioIcon = makeIcon('FileAudioIcon', FileAudioIconSvg)
